<template lang="html">
  <v-flex pa-0>
    <!-- <v-flex xs12 v-if="section.textPre" v-html="_templateLiteralString(section.textPre)"></v-flex> -->
    <v-flex
      v-if="section.textPre"
      xs12
      v-html="section.textPre"
    />

    <v-simple-table class="si-plain-table align-rows-top">
      <template v-for="(schedule, sid) in schedules">
        <tr :key="`title_${sid}`">
          <td class="pr-0 py-2 px-1 subtitle-2">
            {{ schedule.title }}
          </td>
        </tr>
        <tbody
          v-for="(component, ci) in schedule.components"
          :key="ci"
        >
          <tr
            v-for="(fnc, i) in component.formula"
            :key="`component_formula_${i}`"
          >
            <td
              class="pr-0 py-2 px-1 pr-6 si-formula-label"
              v-html="fnc.label"
            />
            <td class="pl-0 py-2 px-1">
              <v-layout
                v-if="fnc.formula"
                ma-0
              >
                <v-flex
                  shrink
                  py-0
                  px-1
                >
                  =
                </v-flex><v-flex
                  shrink
                  py-0
                  px-1
                  v-html="fnc.formula"
                />
              </v-layout>
              <v-layout
                v-if="fnc.working"
                ma-0
              >
                <v-flex
                  shrink
                  py-0
                  px-1
                >
                  =
                </v-flex><v-flex
                  shrink
                  py-0
                  px-1
                  v-html="fnc.working"
                />
              </v-layout>
              <v-layout
                v-if="fnc.result"
                ma-0
              >
                <v-flex
                  shrink
                  py-0
                  px-1
                >
                  =
                </v-flex><v-flex
                  shrink
                  py-0
                  px-1
                  v-html="fnc.result"
                />
              </v-layout>
              <div>
                <tbody>
                  <tr
                    v-for="(fac, i) in component.factors"
                    :key="`component_factors_${i}`"
                  >
                    <td
                      class="pr-0 py-2 px-1 pr-6 si-formula-label"
                      v-html="fac.label"
                    />
                    <td class="pl-0 py-2 px-1">
                      <v-layout
                        v-if="fac.formula"
                        ma-0
                      >
                        <v-flex
                          shrink
                          py-0
                          px-1
                        >
                          =
                        </v-flex><v-flex
                          shrink
                          py-0
                          px-1
                          v-html="fac.formula"
                        />
                      </v-layout>
                      <v-layout
                        v-if="fac.working"
                        ma-0
                      >
                        <v-flex
                          shrink
                          py-0
                          px-1
                        >
                          =
                        </v-flex><v-flex
                          shrink
                          py-0
                          px-1
                          v-html="fac.working"
                        />
                      </v-layout>
                      <v-layout
                        v-if="fac.result"
                        ma-0
                      >
                        <v-flex
                          shrink
                          py-0
                          px-1
                        >
                          =
                        </v-flex><v-flex
                          shrink
                          py-0
                          px-1
                          v-html="fac.result"
                        />
                      </v-layout>
                    </td>
                  </tr>
                </tbody>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody :key="`formula_${sid}`">
          <tr
            v-for="(fnc, i) in schedule.formula"
            :key="`schedule_formula_${i}`"
          >
            <td
              class="pr-0 py-2 px-1 pr-6 si-formula-label"
              v-html="fnc.label"
            />
            <td class="pl-0 py-2 px-1">
              <v-layout
                v-if="fnc.formula"
                ma-0
              >
                <v-flex
                  shrink
                  py-0
                  px-1
                >
                  =
                </v-flex><v-flex
                  shrink
                  py-0
                  px-1
                  v-html="fnc.formula"
                />
              </v-layout>
              <v-layout
                v-if="fnc.working"
                ma-0
              >
                <v-flex
                  shrink
                  py-0
                  px-1
                >
                  =
                </v-flex><v-flex
                  shrink
                  py-0
                  px-1
                  v-html="fnc.working"
                />
              </v-layout>
              <v-layout
                v-if="fnc.result"
                ma-0
              >
                <v-flex
                  shrink
                  py-0
                  px-1
                >
                  =
                </v-flex><v-flex
                  shrink
                  py-0
                  px-1
                  v-html="fnc.result"
                />
              </v-layout>
              <div>
                <tbody>
                  <tr
                    v-for="(fac, i) in schedule.factors"
                    :key="`schedule_factors_${i}`"
                  >
                    <td
                      class="pr-0 py-2 px-1 pr-6 si-formula-label"
                      v-html="fac.label"
                    />
                    <td class="pl-0 py-2 px-1">
                      <v-layout
                        v-if="fac.formula"
                        ma-0
                      >
                        <v-flex
                          shrink
                          py-0
                          px-1
                        >
                          =
                        </v-flex><v-flex
                          shrink
                          py-0
                          px-1
                          v-html="fac.formula"
                        />
                      </v-layout>
                      <v-layout
                        v-if="fac.working"
                        ma-0
                      >
                        <v-flex
                          shrink
                          py-0
                          px-1
                        >
                          =
                        </v-flex><v-flex
                          shrink
                          py-0
                          px-1
                          v-html="fac.working"
                        />
                      </v-layout>
                      <v-layout
                        v-if="fac.result"
                        ma-0
                      >
                        <v-flex
                          shrink
                          py-0
                          px-1
                        >
                          =
                        </v-flex><v-flex
                          shrink
                          py-0
                          px-1
                          v-html="fac.result"
                        />
                      </v-layout>
                    </td>
                  </tr>
                </tbody>
              </div>
            </td>
          </tr>
        </tbody>
      </template>

      <!-- </v-simple-table> -->

      <!-- <v-simple-table class="si-plain-table align-rows-top"> -->
      <tr>
        <td
          class="pr-0 py-2 px-1"
          colspan="2"
        >
          <v-divider />
        </td>
      </tr>
      <tr>
        <td class="pr-0 py-2 px-1 subtitle-2">
          Total valulation
        </td>
      </tr>
      <tbody>
        <tr
          v-for="(fnc, i) in formula"
          :key="`formula_${i}`"
        >
          <td
            class="pr-0 py-2 px-1 pr-6 si-formula-label"
            v-html="fnc.label"
          />
          <td class="pl-0 py-2 px-1">
            <v-layout
              v-if="fnc.formula"
              ma-0
            >
              <v-flex
                shrink
                py-0
                px-1
              >
                =
              </v-flex><v-flex
                shrink
                py-0
                px-1
                v-html="fnc.formula"
              />
            </v-layout>
            <v-layout
              v-if="fnc.working"
              ma-0
            >
              <v-flex
                shrink
                py-0
                px-1
              >
                =
              </v-flex><v-flex
                shrink
                py-0
                px-1
                v-html="fnc.working"
              />
            </v-layout>
            <v-layout
              v-if="fnc.result"
              ma-0
            >
              <v-flex
                shrink
                py-0
                px-1
              >
                =
              </v-flex><v-flex
                shrink
                py-0
                px-1
                v-html="fnc.result"
              />
            </v-layout>
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <!-- <v-flex xs12 v-if="section.textPost" v-html="_templateLiteralString(section.textPost)"></v-flex> -->
    <v-flex
      v-if="section.textPost"
      xs12
      v-html="section.textPost"
    />
  </v-flex>
</template>

<script>
import helpers from '@/mixins/helpers'
export default {
  mixins: [ helpers ],
  props: {
    data: {
      type: Object,
      default: () => { return {} }
    },
    section: Object
  },
  computed: {
    report () {
      return this.data.report || {}
    },
    formula () {
      return this.report.formula || []
    },
    schedules () {
      return this.report.schedules || {}
    }
  },
  methods: {

  }
}
</script>

<style lang="css" scoped>
  @media screen and (min-width: 960px) {
  .si-formula-label {
      white-space: nowrap;
      width: 10px;
    }
  }
</style>
